import { useEffect, useState } from 'react';

const LayoutSwitcher = () => {
  const envLayout = process.env.REACT_APP_LAYOUT || 'V1';

  const [layout, setLayout] = useState(envLayout);

  // Load saved layout
  useEffect(() => {
    const saved = localStorage.getItem('app_layout');
    if (saved) {
      setLayout(saved);
    }
  }, []);

  const handleChange = (e) => {
    const selected = e.target.value;

    localStorage.setItem('app_layout', selected);

    // Reload entire app
    window.location.reload();
  };

  return (
    <div>
      <select
        value={layout}
        onChange={handleChange}
        className="language-dropdown form-select form-select-sm border-0 bg-secondary bg-opacity-25 text-white shadow-none"
         style={{ width: '100px', fontSize: '13.5px', height: '34px' }}
      >
        <option value="V1" className="text-dark">Navbar</option>

        <option value="V2" className="text-dark">Sidebar </option>
        <option value="V3" className="text-dark">Navigation Page </option>
      </select>
    </div>
  );
};

export default LayoutSwitcher;
